export const TUTORIAL_ORDER_CARD_INITIAL = 'OrderCardInitialTutorial';
export const TUTORIAL_MANAGE_COURIERS_SETTING_TIPS = 'ManageCourierSettingTipsTutorial';
export const TUTORIAL_MANAGE_COURIERS_ORDER_HIDE = 'ManageCourierOrderHideTutorial';
export const TUTORIAL_DASHBOARD = 'DashboardUsageTutorial';
export const TUTORIAL_DASHBOARD_REMINDER = 'DashboardTutorialReminder';
export const TUTORIAL_STATISTICS = 'RestaurantStatisticsTutorial';
export const TUTORIAL_ORDER_CLUSTER = 'OrderClusterTutorial';
export const TUTORIAL_OCF = 'OCFTutorial';
